import { Modal, Text } from "@mantine/core";
import { IconGift } from "@tabler/icons";
import { RedeemBenefits } from "./redeem-benefits";

/**
 * RedeemBenefitsModal component (UI: utilize / value)
 *
 * Props:
 * - isOpen: boolean - whether the modal is open
 * - onClose: function - callback when modal is closed
 * - membershipId: string - membership ID for value lookup
 * - totalBillAmount: number - total bill amount for validation
 * - onRedeem: function(selectedBenefits) - callback when value is utilized
 */
export const RedeemBenefitsModal = ({
  isOpen,
  onClose,
  membershipId,
  totalBillAmount,
  onRedeem,
}) => {
  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title={
        <div className="d-flex align-items-center">
          <IconGift size={20} className="me-2" />
          <Text weight={600}>Utilize Value</Text>
        </div>
      }
      size="2xl"
      zIndex={55}>
      <RedeemBenefits
        membershipId={membershipId}
        onRedeem={onRedeem}
        totalBillAmount={totalBillAmount}
      />
    </Modal>
  );
};
